// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-container {
  display: flex;
  align-items: center;
  border: 1px solid #636279;
  border-radius: 10px;
  padding: 5px;
  width: 60vw;
  height: 2.5vh;
  outline: none;
}

.search-icon {
  margin-right: 10px;
  color: #333;
  height: 2.5vh;
}

.search-input {
  background: transparent;
  width: 100%;
  border: none;
  outline: none;
} `, "",{"version":3,"sources":["webpack://./src/components/input-field/textbox/TextBox.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,aAAa;AACf","sourcesContent":[".search-container {\n  display: flex;\n  align-items: center;\n  border: 1px solid #636279;\n  border-radius: 10px;\n  padding: 5px;\n  width: 60vw;\n  height: 2.5vh;\n  outline: none;\n}\n\n.search-icon {\n  margin-right: 10px;\n  color: #333;\n  height: 2.5vh;\n}\n\n.search-input {\n  background: transparent;\n  width: 100%;\n  border: none;\n  outline: none;\n} "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
